import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";
import { IInputCreateLeads, IValuesFilterLeads } from "../LeadsTypes";

export const valuesDefaultInputLeads: IInputCreateLeads = {
  name: "",
  sourceCollection: "INDICATION",
  status: "NEW",
  entityType: " ",
  interestLevel: "MEDIUM",
  captureAt: `${GetDateUSSemValue()}`,
  email: "",
  whats: "",
  birthDate: "",
  telefone1: "",
  observation: "",
  cpf: "",
  pendingActions: "",
  reasonAbandonment: "",
  descriptionPlan: "",
  isPlan: null,
};

export const valuesDefaultFilterLeads: IValuesFilterLeads = {
  name: "",
  sourceCollection: " ",
  status: " ",
  interestLevel: " ",
};
